import * as React from 'react';

import { IMessagePage, IParsedMessage } from '../../../types/messages';

function createMessagePage([year, month, day]: [number, number, number], timeCode: string): IMessagePage {
  return {
    date: new Date(year, month, day).getTime(),
    messages: [],
    timeCode,
  };
}

export const useMessagesPages = (chatMessages: IParsedMessage[]): IMessagePage[] => {
  const pages = React.useMemo(() => {
    const pages: IMessagePage[] = [];

    chatMessages.forEach(message => {
      // timePageKey - идентификатор в виде Год/Месяц/Число
      const pageIndex = pages.findIndex(({ timeCode }) => timeCode === message.timePageKey);

      // если есть страница, обновляем ее
      if (pageIndex >= 0) {
        pages[pageIndex] = {
          ...pages[pageIndex],
          messages: pages[pageIndex].messages.concat(message),
        };

        return;
      }

      // создаем новую страницу и добавляем в нее сообщение
      // timePage - массив даты [Год, Месяц, Число]
      const page = createMessagePage(message.timePage, message.timePageKey);

      page.messages.push(message);

      pages.push(page);

      return;
    });

    // Добавляем поле animation к последнему сообщению с офферами на последней странице
    if (pages.length > 0) {
      const lastPage = pages[pages.length - 1];
      const lastMessageWithOffer = [...lastPage.messages].reverse().find(msg => {
        const offers = msg?.message?.offers;

        return Array.isArray(offers) && offers.length > 0;
      });

      if (lastMessageWithOffer && lastMessageWithOffer.message) {
        pages[pages.length - 1] = {
          ...lastPage,
          messages: lastPage.messages.map(msg =>
            msg.messageId === lastMessageWithOffer.messageId
              ? { ...msg, message: { ...msg.message, animation: true } }
              : msg,
          ),
        };
      }
    }

    return pages;
  }, [chatMessages]);

  return pages || [];
};
